<template>
  <div class="ChartCanvas">
    <canvas :id="ChartId" class="canvascenter"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "BarChart",
  props: [
    "ChartId",
    "ChartLabel",
    "ChartData",
    "ChartColor",
    "ChartHead",
    "LegendDisplay",
    "ChartData1",
    "ChartColor1",
    "ChartHead1",
    "ChartWidth",
    "ChartHeight",
  ],
  data() {
    return {
      barChartData: {
        type: "bar",
        data: {
          labels: this.ChartLabel,
          datasets: [
            {
              label: this.ChartHead,
              backgroundColor: this.ChartColor,
              data: this.ChartData,
              barThickness: 20,
            },
            {
              label: this.ChartHead1,
              backgroundColor: this.ChartColor1,
              data: this.ChartData1,
              barThickness: 20,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "",
            },
            legend: {
              display: this.LegendDisplay,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              stacked: true,
            },
            y: {
              stacked: true,
              grid: {
                display: false,
              },
            },
          },
        },
      },
    };
  },
  methods: {
    refreshChart() {
      const ctx = document.getElementById(this.ChartId);
      if (this.ChartWidth == 0 || this.ChartWidth != null) {
        ctx.width = parseInt(this.ChartWidth);
      }
      if (this.ChartHeight == 0 || this.ChartHeight != null) {
        ctx.height = parseInt(this.ChartHeight);
      }
      // ctx.height = 280;
      // ctx.width = 350;
      new Chart(ctx, this.barChartData);
    },
  },
};
</script>
<style scoped>
.ChartCanvas {
  text-align: center;
}
.canvascenter {
  margin: 0px auto;
}
</style>
